var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Facebook",
    filter: "url(#filter0_d_462_2439)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval 10",
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8262 37.0049C32.5192 37.0049 39.5664 30.0538 39.5664 21.479C39.5664 12.9043 32.5192 5.95312 23.8262 5.95312C15.1331 5.95312 8.08594 12.9043 8.08594 21.479C8.08594 30.0538 15.1331 37.0049 23.8262 37.0049Z",
    stroke: "#12110B",
    strokeWidth: 0.782013
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M25.2607 17.5116H26.7074C26.8405 17.5116 26.9485 17.4112 26.9485 17.2875V15.9429C26.9485 15.8191 26.8405 15.7188 26.7074 15.7188H25.2607C23.7986 15.7188 22.6085 16.8245 22.6085 18.1839V19.7526H20.9208C20.7877 19.7526 20.6797 19.853 20.6797 19.9767V21.3213C20.6797 21.445 20.7877 21.5454 20.9208 21.5454H22.6085V26.2516C22.6085 26.3753 22.7166 26.4757 22.8497 26.4757H24.2963C24.4294 26.4757 24.5374 26.3753 24.5374 26.2516V21.5454H26.2251C26.3288 21.5454 26.4209 21.4836 26.4542 21.3922L26.9364 20.0475C26.961 19.9794 26.9485 19.9041 26.9031 19.8454C26.8573 19.7871 26.785 19.7526 26.7074 19.7526H24.5374V18.1839C24.5374 17.8132 24.8619 17.5116 25.2607 17.5116Z",
    fill: "#12110B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_462_2439",
    x: 0.657195,
    y: 0.870421,
    width: 46.338,
    height: 45.9122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.34604
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.51906
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_462_2439"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_462_2439",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.96cdab051455cb68b170e0cb981d45e9.svg";
export { ForwardRef as ReactComponent };